'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reduxImmutable = require('redux-immutable');

var _selectedElementsReducer = require('./selectedElementsReducer');

var _selectedElementsReducer2 = _interopRequireDefault(_selectedElementsReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Lib
exports.default = (0, _reduxImmutable.combineReducers)({
    selectedElements: _selectedElementsReducer2.default
});

// Reducers


//////////////////
// WEBPACK FOOTER
// ./src/client/remoteActivity/remoteActivityReducer.js
// module id = 2044
// module chunks = 0